import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import keycloak from './keycloak';
import './index.css';

keycloak.init({ onLoad: 'login-required', pkceMethod: 'S256', checkLoginIframe: false })
  .then((authenticated) => {
    if (!authenticated) return;

    const root = ReactDOM.createRoot(document.getElementById('root'));

    const roles = keycloak.resourceAccess?.['fair-products-app']?.roles || [];
    if (!roles.includes('manager') && !roles.includes('support')) {
      root.render(
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',
                      justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif' }}>
          <h2>Kein Zugriff</h2>
          <p>Ihr Konto hat keine Berechtigung für diese Anwendung.</p>
          <button onClick={() => keycloak.logout()} style={{ marginTop: 24, padding: '8px 20px', cursor: 'pointer' }}>
            Abmelden
          </button>
        </div>
      );
      return;
    }

    root.render(<React.StrictMode><App /></React.StrictMode>);
  });
